import { render } from "./theme.vue?vue&type=template&id=35a7d71c&scoped=true"
import script from "./theme.vue?vue&type=script&lang=js"
export * from "./theme.vue?vue&type=script&lang=js"

import "./theme.vue?vue&type=style&index=0&id=35a7d71c&lang=scss&scoped=true"

import exportComponent from "E:\\Gitlab\\02_各园区PC端\\happyHarbour\\ningbo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35a7d71c"]])

export default __exports__